module.exports = __webpack_public_path__ + "static/media/Orpheus.8ffc9b2a.jpg";